import eventBus from '@/services/eventBus';

const ToastService = {
  success(title, message) {
    this.show(title, message, 'success');
  },
  error(title, message) {
    this.show(title, message, 'danger');
  },
  info(title, message) {
    this.show(title, message, 'info');
  },
  warning(title, message) {
    this.show(title, message, 'warning');
  },
  show(title, body, variant = 'info', delay = 5000) {
    eventBus.emit('toast:show', { title, body, variant, delay });
  },
};

export default ToastService;
